import axios from "axios";
import ElementUI, { Loading, Message } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import md5 from "js-md5";
import Vue from "vue";
import App from "./App";
import "./assets/main.css";
import router from "./router";
import store from "./store";
Vue.use(ElementUI);
Vue.prototype.$ajax = axios;
Vue.prototype.$md5 = md5;
Vue.config.productionTip = false;

let loading;
function startLoading() {
  loading = Loading.service({
    lock: true,
    text: "加载中....",
    // background: 'rgba(0, 0, 0, 0.7)'
    target: document.querySelector(".loading-area") //设置加载动画区域
  });
}

function endLoading() {
  loading.close();
}

// 声明一个对象用于存储请求个数
let needLoadingRequestCount = 0;
function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading();
  }
  needLoadingRequestCount++;
}
function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    endLoading();
  }
}

//  请求拦截
axios.interceptors.request.use(
  config => {
    // startLoading();
    showFullScreenLoading();
    config.headers = {
      "Content-Type": "application/json"
    };
    //设置请求头
    return config;
  },
  error => {
    endLoading();
    return Promise.reject(error);
  }
);

// 响应拦截
axios.interceptors.response.use(
  function(response) {
    // 对响应数据做点什么
    // endLoading();
    tryHideFullScreenLoading();
    if (response.data.code) {
      switch (response.data.code) {
        case 200:
          return response.data;
        // break;
        case 10001:
          window.sessionStorage.removeItem("masterId");
          Message.error(response.data.message);
          setTimeout(function() {
            router.replace({
              name: "login"
            });
          }, 1000);
          break;
        default:
          // return response.data;
          Message.error(response.data.message);
          // 对响应错误做点什么
          return Promise.reject(response.data.message);
        // return null;
        // break;
      }
    } else {
      if (response.status == 200) {
        return response.data;
      }
    }
  },
  function(err) {
    // endLoading();
    tryHideFullScreenLoading();
    if (err.response.status == 504 || err.response.status == 404) {
      Message.error({ message: "服务器被吃了⊙﹏⊙∥" });
    } else if (err.response.status == 403) {
      Message.error({ message: "权限不足,请联系管理员!" });
    } else {
      Message.error({ message: "未知错误" });
    }
    // 对响应错误做点什么
    return Promise.reject(err);
  }
);

// Vue.prototype.$store = store;

new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js